/* Belle's Secrets — header interactions (drawer, sticky shadow, mega a11y) */
(function () {
  function init(root) {
    if (root.dataset.bsHeaderReady) return;
    root.dataset.bsHeaderReady = '1';

    var drawer = root.querySelector('[data-bs-drawer]');
    var openBtn = root.querySelector('[data-bs-drawer-open]');
    var closeEls = root.querySelectorAll('[data-bs-drawer-close]');
    var body = document.body;

    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false;
      // force reflow so transition runs
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      body.style.overflow = 'hidden';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      body.style.overflow = '';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      window.setTimeout(function () { drawer.hidden = true; }, 380);
    }
    if (openBtn) openBtn.addEventListener('click', openDrawer);
    closeEls.forEach(function (el) { el.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    });

    /* Sticky shadow on scroll */
    if (root.classList.contains('bs-header--sticky')) {
      var onScroll = function () {
        if (window.scrollY > 8) root.classList.add('is-scrolled');
        else root.classList.remove('is-scrolled');
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    /* Mega menu: click/keyboard toggle for touch + a11y (hover handled by CSS) */
    var triggers = root.querySelectorAll('[data-bs-mega-trigger]');
    triggers.forEach(function (trigger) {
      var item = trigger.closest('.bs-header__item');
      var mega = item && item.querySelector('[data-bs-mega]');
      if (!mega) return;
      trigger.addEventListener('click', function (e) {
        // Only intercept when it behaves like a touch/no-hover device
        if (window.matchMedia('(hover: none)').matches || window.matchMedia('(min-width: 990px)').matches === false) return;
      });
      // keyboard: close on escape, moving focus back to trigger
      mega.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { trigger.focus(); }
      });
    });
  }

  function boot() {
    document.querySelectorAll('bs-header, .bs-header').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
